import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Row, Col } from 'antd'
import _ from 'lodash'

import * as actions from './TemplateListPageActions'
import TemplateList from '../Commons/TemplateList/TemplateList'
import './TemplateListPage.scss'

export class TemplateListPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            templateList: [],
            filter: {
                category: undefined,
                type: undefined,
                size: undefined,
                siteLocation: undefined,
                estateName: undefined
            },
            searchBarInput: '',
            selectedTemplateIdx: null,
            selectedMember: undefined
        }

        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.handleSearchBarInputChange = this.handleSearchBarInputChange.bind(this)
    }

    filterTemplate() {
        const { templateList } = this.props
        const { filter, searchBarInput } = this.state
        let newTemplateList = _.cloneDeep(templateList)
        let filterCondition = {}

        _.forEach(filter, (value, key) => {
            if (value && key !== 'size') {
                filterCondition[_.snakeCase(key)] = value
            }
        })

        newTemplateList = _.filter(newTemplateList, filterCondition)

        if (filter.size) {
            switch (filter.size) {
                case '<= 300':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size <= 300)
                    break
                case '301 - 500':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size > 300 && project.size <= 500)
                    break
                case '501 - 800':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size > 500 && project.size <= 800)
                    break
                case '> 800':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size > 800)
                    break
                default:
            }
        }

        newTemplateList = _.filter(newTemplateList, (project) => {
            return _.filter(_.map(_.values(project), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchBarInput.toUpperCase()) !== -1).length !== 0
        })

        this.setState({ templateList: newTemplateList })
    }

    handleFilterChange(field, value) {
        let newFilter = _.cloneDeep(this.state.filter)
        newFilter[field] = value

        this.setState({ filter: newFilter })
    }

    handleSearchBarInputChange(value) {
        this.setState({ searchBarInput: value })
    }

    componentWillMount() {
        const { fetchTemplateList, updateSelectedProject, fetchLocationList, fetchEstateList, token } = this.props

        fetchLocationList(token)
        fetchEstateList(token)
        fetchTemplateList(token)
        updateSelectedProject({})
    }

    componentDidUpdate(prevProps, prevState) {
        const { templateList } = this.props
        const { filter, searchBarInput } = this.state

        if (!_.isEqual(prevProps.templateList, templateList)) {
            this.setState({ templateList })
        }

        if (!_.isEqual(prevState.filter, filter) || prevState.searchBarInput !== searchBarInput || !_.isEqual(prevProps.templateList, templateList)) {
            this.filterTemplate()
        }
    }

    render() {
        const { locationList, estateList } = this.props
        const { templateList, filter } = this.state

        const parentColumns = [
            { title: 'Template', dataIndex: 'name', key: 'name', render: (name, record) => <NavLink to={`/workdesk/template/${record._id}`} activeClassName="active-link">{name}</NavLink> },
            { title: 'Estate Name', dataIndex: 'estate_name', key: 'estate_name', render: data => data || 'N/A' },
            { title: 'Type', dataIndex: 'type', key: 'type', render: data => data || 'N/A' },
            { title: 'Size', dataIndex: 'size', key: 'size', render: data => data || 'N/A' },
        ]

        return (
            <div className="TemplateListPage">
                <Row gutter={8}>
                    <Col span={24}>
                    	<TemplateList
                    		filter={filter}
                            locationList={locationList}
                            estateList={estateList}
                    		dataset={templateList}
                    		onFilterChange={this.handleFilterChange}
                            onSearchBarInputChange={this.handleSearchBarInputChange}
                    		parentColumns={parentColumns}
                    	/>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        templateList: state.templateListPage.templateList,
        locationList: state.app.locationList,
        estateList: state.app.estateList,
    }
}

export default connect(mapStateToProps, actions)(TemplateListPage)



// WEBPACK FOOTER //
// ./src/TemplateListPage/TemplateListPage.js